import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  VerticalProgress,
  PushButton,
} from '../components';
import {
  Sound,
  Sounds,
} from '../../Sound';
import convertUnit from '../../../utils/unit-converter';
import { toNumber } from '../../../utils/numbers';
import {
  TargetLabel,
  BalanceLabel,
  DeviceStatusLabel,
} from '../components/labels';
import { DeviceStatus } from '../../../constants/DeviceStatus';
import Stopwatch from '../../Stopwatch/Stopwatch';

@observer
class WaterScale extends Component {
  render() {
    const { device, batchStore, onOpen } = this.props;
    const name = device.description || `#${device.id}`;
    const active = batchStore.isScaleOpen(device);
    const gateAnimation = active ? 'gate-open' : 'gate-close';
    const deviceStatus = batchStore.getDeviceStatus(device.id);
    const { status, target, unit, uid, tId, truckCode, currentDrop, allDrops, error, startTime } = deviceStatus;
    const isError = error ? 'error' : '';
    const mCode = uid ? `${truckCode || tId || uid} ${currentDrop}/${allDrops}` : '';
    const weight = batchStore.getScaleWeight(device);
    const indicatorError = batchStore.isIndicatorValueError(weight) ? DeviceStatus.INDICATOR_ERROR : '';
    const progress = weight > 0 ? 100 - (((target - weight) / target) * 100) : 0;
    const materialAnimation = weight > 0 && active ? 'material-animation' : '';
    const inputDisabled = batchStore.isInputDisabled(device.gateOneStatusPNo) ? 'device-input-disabled' : '';
    const holdDischargeIcon = batchStore.isHoldScale(device.id) ? 'play' : 'pause';
    const openButtonDisabled = batchStore.shouldOpenButtonBeDisabled(device);
    const interlockIsOff = device.interlockStatusPNo ? batchStore.isInputPortOff(device.interlockStatusPNo) : '';

    const deviceUnit = batchStore.getUnitById(device.unitId);
    const batchUnit = unit || deviceUnit;
    const isDeferenceUnit = unit && target ? unit !== deviceUnit : false;
    let convertedTarget;
    let convertedWeight;

    if (isDeferenceUnit) {
      convertedTarget = toNumber(convertUnit(target, deviceUnit, batchUnit), 0);
      convertedWeight = toNumber(convertUnit(weight, deviceUnit, batchUnit), 0);
    }

    const delay = device.dischargeOpenDelay || 0;

    return (
      <div id={`device-${device.id}`} className={`${gateAnimation} ${materialAnimation} status-${status} device-gui device-gui--water-scale device-${isError} ${inputDisabled}`}>
        <Sound file={Sounds.alarm} play={isError} loop={true}/>
        <DeviceStatusLabel
          name={name}
          status={status}
          title={`#${device.id} ${inputDisabled}`}
          displayIcon={inputDisabled}
          interlockIcon={interlockIsOff}
          isHorizontal={true}
        />

        {!!delay && (
          <div className="scale-countdown device-label">
            <Stopwatch start={startTime} startTime={startTime} stop={!startTime} delay={delay} countdown={true} hideIcon={true} />
          </div>
        )}

        <div className="device-label device-label-target">
          <TargetLabel target={toNumber(target, 0)} unit={deviceUnit} convertedTarget={convertedTarget} convertedUnit={batchUnit} padZeros={device.graduation > 1}/>
          <BalanceLabel balance={indicatorError || weight} unit={deviceUnit} convertedBalance={convertedWeight} convertedUnit={batchUnit} padZeros={device.graduation > 1}/>
          {mCode && <div className="mix" title={mCode}>{mCode}</div>}
        </div>

        {device.inputPNo && (
          <button className="btn-batch btn-batch-red btn-reset-indicator"
            title="Reset weight"
            onClick={() => batchStore.resetIndicator(device.inputPNo)}>
            <i className="fa fa-refresh"/>
          </button>
        )}

        {uid && ([DeviceStatus.DISCHARGING, DeviceStatus.HOLD, DeviceStatus.WAIT_WATER].includes(status))
          && !batchStore.isScaleFinishedDischargeEarlier(device.id)  && (
          <button className={'btn-on btn-batch btn-batch-red btn-hold-discharge'}
            title={batchStore.isHoldScale(device.id) ? 'Start discharge' : 'Hold discharge'}
            onClick={() => batchStore.onWaterScaleHold(device)}
          >
            <i className={`fa fa-${holdDischargeIcon}`}/>
          </button>
        )}
        {batchStore.isHoldScale(device.id) && uid && !batchStore.isScaleFinishedDischargeEarlier(device.id) && (
          <button className={'btn-on btn-batch btn-batch-red btn-finish-discharge'}
            title="Finish discharge"
            onClick={() => batchStore.finishDischargeScaleEarlier(device.id)}>
            <i className={'fa fa-stop'}/>
          </button>
        )}

        <div className="device-icon water"/>
        <div className="device-icon scale-gate"/>
        <div className={'device-icon particle'}/>
        <VerticalProgress
          showPercent={true}
          showProgress={true}
          tolerance={{over: 2, under: 2}}
          value={progress}
          active={active}
        />
        <div className="device-gui__row">
          <PushButton
            port={device.openGateOnePNo}
            onPush={() => onOpen(device.openGateOnePNo)}
            disabled={openButtonDisabled}
            onRightClickHoldStart={() => onOpen(device.openGateOnePNo)}
            onRightClickHoldLabel={'Hold to keep open..'}
            onRightClickHoldEnd={() => onOpen(device.openGateOnePNo)}
            rightClickHoldDuration={1250}
          >
          </PushButton>
        </div>
      </div>
    );
  }
}

export default WaterScale;
